module.exports = __webpack_public_path__ + "static/media/asana.74e7a75c.svg";